import { FC } from 'react';

import CustomLoading from 'modules/_shared/components/CustomLoading';

import { useUploadDocumentModal } from './context/UploadDocumentModalContext';
import UploadDocumentModalHeader from './components/UploadDocumentModalHeader';
import UploadDocumentModalBody from './components/UploadDocumentModalBody';
import UploadDocumentModalFooter from './components/UploadDocumentModalFooter';

const UploadDocumentModal: FC = () => {
  const { data } = useUploadDocumentModal();
  return (
    <>
      <UploadDocumentModalHeader />
      <UploadDocumentModalBody />
      <UploadDocumentModalFooter />

      {data.isLoading && <CustomLoading />}
    </>
  );
};

export default UploadDocumentModal;
